// SignatureBlock: Unterschrift mit Signaturprotokoll am Ende eines Dokuments (Ansicht und Druck).
export function SignatureBlock({
  name,
  signedAt,
  ip,
  contentHash,
  imageUrl,
  earlyStart,
}: {
  name: string;
  signedAt: string | null;
  ip: string | null;
  contentHash: string;
  imageUrl: string | null;
  earlyStart: boolean;
}) {
  const when = signedAt ? new Date(signedAt).toLocaleString('de-DE', { dateStyle: 'medium', timeStyle: 'short' }) : '';
  return (
    <section className="signature-block" aria-label="Elektronische Unterschrift">
      {imageUrl && <img src={imageUrl} alt={`Unterschrift ${name}`} />}
      <p>
        <strong>{name}</strong> – elektronisch unterschrieben am {when}
      </p>
      {earlyStart && <p>Der Unterzeichner hat ausdrücklich verlangt, dass der Makler vor Ablauf der Widerrufsfrist beginnt.</p>}
      <p className="signature-protocol">
        Signaturprotokoll: einfache elektronische Signatur über Maklerpass{ip ? ` · IP ${ip}` : ''} · Prüfsumme (SHA-256) {contentHash}
      </p>
    </section>
  );
}
